module.exports = __webpack_public_path__ + "img/part_time_recruitment.f028d11.webp";